import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {

    const colorSacola =
        theme.palette.type === 'light'
            ? theme.palette.primary.main
            : theme.palette.text.primary;

    return {
        header: {
            width: '100%',
            minHeight: 60,
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            padding: theme.spacing(1, 0),
            flex: 1,
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.04)',
        },
        content: {
            marginRight: 8,
            display: "flex",
            [theme.breakpoints.down('sm')]: {
                marginRight: 10
            }
        },
        iconVoltar: {
            paddingLeft: theme.spacing(1),
            color: colorSacola,
            width: 40,
            height: 40
        },
        icon: {
            fill: colorSacola,
            height: theme.spacing(4.5),
            width: theme.spacing(4.5),
        },
        label: {
            fontWeight: "bold",
            fontSize: "20px",
            fontStyle: "revert",
            color: colorSacola,
            lineHeight: 0,
            marginTop: 4
        },
        iconSacola: {
            flex: 1,
            height: '45px',
            marginBottom: '5px',
            marginRight: '80px'
        },
        iconButton: {
            position: 'absolute',
            top: 2,
            left: 0,
            padding: theme.spacing(1, 1),
        },
        limparSacola: {
            position: 'absolute',
            top: 8,
            right: 8,
            padding: theme.spacing(1, 1),
        },
        divider: {
        },
        iconVoltarSacola: {
            [theme.breakpoints.down('sm')]: {
                transform: 'rotate(-90deg)',
                display: 'inline-block'
            }
        }
    }
})